export default __webpack_public_path__ + "static/media/section3-bg1.db2c6c55.png";